import { GroupFilterKey } from '../domain';
import { useSetFilter } from '../../filter';

export const useSetGroupListFilter = () => {
  return useSetFilter(GroupFilterKey, 'groupFilter', true);
};
